import { API } from "@thenounproject/lingo-core";
import { createAsyncAction } from "../actionCreators";

type Args = {
  spaceId: number | string;
  kitId: string;
  sourceId: string;
};

const [usePollForDuplicateKit, pollForDuplicateKit] = createAsyncAction(
  "kits/pollForDuplicateKit",
  async ({ kitId, spaceId }: Args) => {
    const res = await API.call<{ kit: string }>({
      endpoint: `kits/${spaceId}/${kitId}`,
      method: "GET",
    });
    return { ...res, result: res.result.kit };
  }
);

export default usePollForDuplicateKit;
export { pollForDuplicateKit };
